import React, { useMemo } from 'react';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpWidgetProps } from '../../types/widget';
import { CpFeatureSectionWidgetRenderData } from './types';
import { CpFeatureWithImageOnLeft } from './variants/cp-feature-with-image-on-left';
import { CpFeatureWithImageOnRight } from './variants/cp-feature-with-image-on-right';

export const CpFeatureWidget: React.FC<CpWidgetProps> = ({
  disabled,
  data,
  widget,
  projectId,
  onRuntimeConfigChange,
  runtimeConfig,
}) => {
  const widgetData = useMemo(
    () => data as CpFeatureSectionWidgetRenderData,
    [data],
  );

  switch (widget?.widgetVariantType) {
    case CpWidgetVariantType.FeatureWithImageOnLeft:
    case undefined:
      return (
        <CpFeatureWithImageOnLeft
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    case CpWidgetVariantType.FeatureWithImageOnRight:
      return (
        <CpFeatureWithImageOnRight
          disabled={disabled}
          data={widgetData}
          widget={widget}
          projectId={projectId}
          onRuntimeConfigChange={onRuntimeConfigChange}
          runtimeConfig={runtimeConfig}
        />
      );
    default:
      return <></>;
  }
};
